import { createSelector } from 'reselect';
import { RouterState } from '../slices/router';
import { RootState } from '../store';

export const routerSelector: (state: RootState) => RouterState = (state: RootState) => state.router;

export const projectIdSelector = createSelector(routerSelector, (state) => state.params?.projectId);
